/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {AsyncPipe, NgIf} from '@angular/common';
import {ChangeDetectionStrategy, Component, OnInit, Optional} from '@angular/core';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {NbButtonModule, NbCardModule, NbFormFieldModule, NbIconModule, NbInputModule, NbTooltipModule, NbWindowRef} from '@nebular/theme';
import {AuthService, AuthStateService, SignInComponent} from 'compob2b-auth';
import {LoginBy, RecoverPasswordBy, SharedModule} from 'compob2b-libs';
import {ForgotPasswordSmsComponent} from '../popup-forgot-password-sms/forgot-sms.component';
import {ForgotPasswordComponent} from '../popup-forgot-password/forgot.component';

@Component({
  selector: 'app-popup-login',
  templateUrl: './login.component.html',
  imports: [
    NbFormFieldModule,
    ReactiveFormsModule,
    NbIconModule,
    RouterLink,
    SharedModule,
    NbTooltipModule,
    NbInputModule,
    NbButtonModule,
    NgIf,
    AsyncPipe,
    NbCardModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupLoginComponent extends SignInComponent implements OnInit {
  checked = false;
  isShowPass = false;
  loginType = this.environment.loginBy;

  constructor(
    userService: AuthService,
    stateService: AuthStateService,
    private readonly popupUserService: AuthService,
    @Optional() protected readonly windowRef?: NbWindowRef,
  ) {
    super(userService, stateService);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.loginType == LoginBy.EMAIL) {
      this.loginForm.controls.login.setValidators([Validators.required, Validators.email]);
    }
  }

  register(): void {
    this.router.navigate(['cabinet', 'sign-up']).then(_ => this.close());
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      if (this.loginType == LoginBy.PHONE) {
        this.patchPhone();
      }

      this.popupUserService.signIn(this.loginForm.value).subscribe(_ => this.reloadNavigation());
    }
  }

  patchPhone() {
    let onlyNumeric = this.loginForm.controls.login.value.replace(/\D/g, '');

    if (onlyNumeric.length > 12) {
      onlyNumeric = onlyNumeric.substring(0, 12);
    }

    const firstChar = onlyNumeric[0];
    const phone = firstChar === '3' ? onlyNumeric : '7' + onlyNumeric.substring(1);

    this.loginForm.controls.login.patchValue(phone);
  }

  togglePass() {
    this.isShowPass = !this.isShowPass;
  }

  forgot() {
    const opt = {
      title: 'Восстановление пароля',
      windowClass: 'small',
    };

    if (this.environment.recoverPasswordBy === RecoverPasswordBy.EMAIL) {
      this.windowService.open(ForgotPasswordComponent, opt);
    }

    if (this.environment.recoverPasswordBy === RecoverPasswordBy.SMS) {
      this.windowService.open(ForgotPasswordSmsComponent, opt);
    }

    this.close();
  }

  close() {
    this.windowRef?.close();
  }

  reloadNavigation() {
    if (window.location.href.indexOf('/sign') > 0) {
      window.location.href = '/';
    } else {
      window.location.href = this.router.url;
    }
  }

  isLoginByPhone() {
    return this.loginType === LoginBy.PHONE;
  }
}
